import {FC} from 'react';
import {useField} from 'formik';
import {teamMemberPhoto} from '../../../../../../assets/symbols/images/teamMemberPhoto';
import CircleImageEdit from '../../../../../../component/circleImageEdit/CircleImageEdit';
import * as css from '../AddLecturerPopup.css';

const ImagePicker: FC = () => {
    const [field, , helpers] = useField<string>('image');
    return (
        <css.imageWrap>
            <CircleImageEdit
                size={{width: 222, height: 222}}
                image={field.value}
                isDefaultImg={field.value === teamMemberPhoto}
                setImage={() => helpers.setTouched(true)}
                saveImage={((img: string) => helpers.setValue(img)) as () => void}
                deleteImage={() => helpers.setValue(teamMemberPhoto)}
            />
        </css.imageWrap>
    );
};

export default ImagePicker;
